import * as React from 'react';

export const ArrowDown = (props: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" className={props.className}>
        <path fill-rule="evenodd" d="M0 5l10 10L20 5z"/>
    </svg>
);



// WEBPACK FOOTER //
// ./src/Assets/images/svg/arrowDown.tsx